<rt-icons-container></rt-icons-container>

<div class="app-content">
  <div class="content-wrap" layout-full-width layout-full-height>
    <rtc-detached-router-outlet></rtc-detached-router-outlet>
  </div>
</div>
